import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=17c6bf8b"
import script from "./DeleteButton.ts?vue&type=script&lang=ts&external"
export * from "./DeleteButton.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports